// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorPage_container___sGiv","title":"ErrorPage_title__3c94J","body":"ErrorPage_body__1o9k7"};